export default __webpack_public_path__ + "static/newsletter-3-d9ac737dbf9aff14efd07dc4f2819912.png";